/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Broadcast from '../../../store/externalCalls/broadcast';
import './websocketLog.scss';

const WebsocketLog = (props) => {
  const {
    title,
    handlerClose,
    onMessageReceived,
    eventChanel,
    websocketParam,
    initialValues,
  } = props;
  const [logs, setLogs] = useState(`${initialValues}<br>`);

  const onBroncastingReceived = (e) => {
    onMessageReceived(e);
    setLogs((previewState) => {
      return `${previewState}<br>${e.message}`;
    });
  };

  useEffect(() => {
    setLogs(initialValues);
  }, [initialValues]);

  return (
    <div>
      <div className="websocket-log" dangerouslySetInnerHTML={{ __html: logs }} />
      <Broadcast
        eventChanel={`${eventChanel}-${websocketParam}`}
        onEventReceived={(e) => onBroncastingReceived(e)}
      />
    </div>
  );
};

WebsocketLog.propTypes = {
  title: PropTypes.string.isRequired,
  eventChanel: PropTypes.string.isRequired,
  websocketParam: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  handlerClose: PropTypes.func,
  initialValues: PropTypes.string,
  onMessageReceived: PropTypes.func,
};

WebsocketLog.defaultProps = {
  handlerClose: () => {},
  onMessageReceived: () => {},
  initialValues: 'Listening...',
};

export default WebsocketLog;
